export default {
  DELETING: 'ADMIN_VIEW_VARIABLES_DELETOR_DELETING',
  DELETED: 'ADMIN_VIEW_VARIABLES_DELETOR_DELETED',
};
